var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-define" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "form-wrap",
      },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "define-form",
            attrs: {
              model: _vm.form,
              rules: _vm.rules,
              "label-width": "123px",
              "label-position": "left",
            },
          },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "form-item",
                        class: { "no-edit-item": _vm.editStatus },
                        attrs: { label: "产品ID（PID）" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.form.productId) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "form-item",
                        class: { "no-edit-item": _vm.editStatus },
                        attrs: { label: "产品类型" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.form.categoryName || "-") +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: { "form-item": !_vm.editStatus },
                        attrs: {
                          label: "客户名称",
                          prop: _vm.editStatus ? "customerCode" : "",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editStatus,
                                expression: "editStatus",
                              },
                            ],
                            attrs: { placeholder: "请选择客户名称" },
                            on: { change: _vm.handleCustomer },
                            model: {
                              value: _vm.form.customerCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "customerCode", $$v)
                              },
                              expression: "form.customerCode",
                            },
                          },
                          _vm._l(_vm.customerData, function (item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: { label: item.name, value: item.code },
                            })
                          }),
                          1
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editStatus,
                                expression: "!editStatus",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.form.customerName || "-"))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: { "form-item": !_vm.editStatus },
                        attrs: {
                          label: "产品名称",
                          prop: _vm.editStatus ? "name" : "",
                        },
                      },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editStatus,
                              expression: "editStatus",
                            },
                          ],
                          attrs: {
                            placeholder: "请输入产品名称",
                            maxlength: "64",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editStatus,
                                expression: "!editStatus",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.form.name || "-"))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: { "form-item": !_vm.editStatus },
                        attrs: {
                          label: "产品型号",
                          prop: _vm.editStatus ? "productModel" : "",
                        },
                      },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editStatus,
                              expression: "editStatus",
                            },
                          ],
                          attrs: {
                            placeholder: "请输入产品型号",
                            maxlength: "64",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.productModel,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "productModel", $$v)
                            },
                            expression: "form.productModel",
                          },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editStatus,
                                expression: "!editStatus",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.form.productModel || "-"))]
                        ),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "设备类型" } }, [
                      _c("span", [_vm._v(_vm._s(_vm.deviceType || "-"))]),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        class: [
                          !_vm.editStatus ? "form-item" : "edit-form-item",
                        ],
                        attrs: {
                          label: "通讯协议",
                          prop: _vm.editStatus ? "communicationProtocol" : "",
                        },
                      },
                      [
                        _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editStatus,
                                expression: "editStatus",
                              },
                            ],
                          },
                          _vm._l(
                            _vm.communicationProtocolData,
                            function (item, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  class: {
                                    selected:
                                      item === _vm.form.communicationProtocol,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectCommunicationProtocol(
                                        index,
                                        item
                                      )
                                    },
                                  },
                                },
                                [_vm._v("\n                " + _vm._s(item))]
                              )
                            }
                          ),
                          0
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editStatus,
                                expression: "!editStatus",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.form.communicationProtocol || "-")
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm.editStatus
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "edit-form-item",
                            attrs: {
                              label: "配网方式",
                              prop: "networkDistributeMode",
                            },
                          },
                          [
                            _c(
                              "ul",
                              _vm._l(_vm.dmsMethods, function (item, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    class: {
                                      selected:
                                        item === _vm.form.networkDistributeMode,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectedDmsMethods(
                                          index,
                                          item
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    !_vm.editStatus
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "form-item",
                            attrs: { label: "配网方式" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.form.networkDistributeMode || "-") +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "form-item-img",
                        class: { "no-edit-item": _vm.editStatus },
                        attrs: { label: "产品图片" },
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editStatus,
                                expression: "editStatus",
                              },
                            ],
                            staticClass: "product-img",
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-img",
                                attrs: {
                                  action: "/admin/sys-file/upload",
                                  headers: _vm.headers,
                                  "show-file-list": false,
                                  "on-success": _vm.handleSuccess,
                                  "on-error": _vm.uploadError,
                                  "before-upload": _vm.beforeUpload,
                                },
                              },
                              [
                                _vm.form.icon
                                  ? _c("img", {
                                      staticClass: "uploaded-img",
                                      attrs: {
                                        src: _vm.uploadUrl || _vm.form.icon,
                                      },
                                    })
                                  : _c("div", [
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-shangchuantupian",
                                      }),
                                      _c("div", { staticClass: "text" }, [
                                        _vm._v("点击上传"),
                                      ]),
                                    ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editStatus,
                                expression: "!editStatus",
                              },
                            ],
                          },
                          [
                            _vm.form.icon
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      _vm.form.icon +
                                      "?t=" +
                                      new Date().getTime(),
                                    alt: "",
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: { "form-item": !_vm.editStatus },
                        attrs: {
                          label: "产品说明",
                          prop: _vm.editStatus ? "description" : "",
                        },
                      },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editStatus,
                              expression: "editStatus",
                            },
                          ],
                          attrs: {
                            type: "textarea",
                            maxlength: "200",
                            "show-word-limit": "",
                            placeholder: "请输入产品说明，尽可能描述清楚",
                            rows: 4,
                          },
                          model: {
                            value: _vm.form.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "description", $$v)
                            },
                            expression: "form.description",
                          },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.editStatus,
                                expression: "!editStatus",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.form.description))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: { "no-edit-item": _vm.editStatus },
                        attrs: { label: "创建时间" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.form.updateTime) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _vm.currentDevelopStatus == 1
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  content: "产品已发布，信息不可修改，如需修改，请返回开发状态",
                  placement: "top",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "disbled" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editStatus,
                            expression: "!editStatus",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          size: "14",
                          disabled:
                            _vm.rolesCode === "SALE" ||
                            _vm.currentDevelopStatus == 1,
                        },
                        on: { click: _vm.onEdit },
                      },
                      [_vm._v("编辑")]
                    ),
                  ],
                  1
                ),
              ]
            )
          : _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editStatus,
                        expression: "!editStatus",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      size: "14",
                      disabled: _vm.rolesCode === "SALE",
                    },
                    on: { click: _vm.onEdit },
                  },
                  [_vm._v("编辑")]
                ),
              ],
              1
            ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.editStatus,
                expression: "editStatus",
              },
            ],
            staticClass: "cancel",
            attrs: { size: "14" },
            on: { click: _vm.onCancel },
          },
          [_vm._v("取消")]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.editStatus,
                expression: "editStatus",
              },
            ],
            attrs: {
              type: "primary",
              size: "14",
              disabled: _vm.saveBtnDisabled,
            },
            on: { click: _vm.onSubmit },
          },
          [_vm._v("保存")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }